<template>
  <BootstrapModal2 v-model="modalShow" :close="true" :backdrop="false" modalSize="md">
    <div class="join-partner-content mb-15">
      <h4 class="join-partner-title">{{ item.displayName }}</h4>
      <!--<p class="text-center join-partner-desc">{{$t('partnerInvite.joinPartnerProgram.desc')}}</p>-->
      <div class="partnerInvite-form form">
        <div class="mb-15 d-flex join-partner-table">
          <table>
            <tr>
              <td class="pr-15 pb-10 join-partner-label">{{ $t('partnerInvite.joinPartnerProgram.partnerLevel') }}</td>
              <td class="join-partner-data pb-10">{{ item.displayName }} {{ pendingInviteLevel }}</td>
            </tr>
            <tr>
              <td class="pr-15 pb-10 join-partner-label">{{ $t('partnerInvite.joinPartnerProgram.fee') }}</td>
              <td class="join-partner-data pb-10">{{ item.price }} {{ item.coinSymbol }}</td>
            </tr>
          </table>
        </div>
        <p class="available-balance">{{ $t('partnerInvite.joinPartnerProgram.balance') }} {{ userBalance }}</p>

        <ValidationObserver ref="observer" v-slot="{ passes }">
          <ValidationProvider :name="$t('labels.txnPwd')" rules="required|txnPwdValid" v-slot="{ errors }">
            <v-text-field
              v-model="form.payPassword"
              single-line
              outlined
              flat
              dense
              :label="$t('labels.txnPwd')"
              :error-messages="errors[0]"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </ValidationProvider>

          <div>
            <div class="check-box-wrap">
              <v-checkbox v-model="checkBoxFlag" class="mb-xs"></v-checkbox>
              <span class="terms-and-condition-spacing" v-html="$t('partnerInvite.joinPartnerProgram.termsAndCondition')"></span>
            </div>
            <div class="must-check-error-text" v-if="mustCheckFlag">
              {{ $t('partnerInvite.joinPartnerProgram.mustCheckText') }}
            </div>
          </div>
          <div class="btns-wrap mt-4">
            <v-btn
              :loading="commitFlag"
              @click="passes(joinPartnerModalSubmitBtn)"
              block
              class="btn-common"
              x-large
              :large="$vuetify.breakpoint.xsOnly"
            >
              {{ $t('actions.payNow') }}
            </v-btn>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </BootstrapModal2>
</template>
<script>
import BootstrapModal2 from '../../components/Modal/BootstrapModal/BootstrapModal2';
// import BootstrapModal2 from '@/components/Modal/BootstrapModal/BootstrapModal2';
// import { required } from 'vuelidate/lib/validators';
//import { rules } from '../../common/constants/rules';
// import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel.js';
import { partnerApi } from '@/api/user/partnerApi';
import { mapActions } from 'vuex';
import { actionTypes } from '@/store/action-types';

export default {
  name: 'JoinAffiliateModal',
  // mixins: [getErrorLabelMixin],
  components: {
    BootstrapModal2
    // BootstrapModal2
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return {
          id: 0,
          displayName: '',
          coinSymbol: '',
          price: 0,
          available: false,
          isUpgrade: false
        };
      }
    },
    pendingInviteLevel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modalShow: false,
      title: '',
      desc: '',
      form: {
        payPassword: ''
      },
      userBalance: '0',
      availBalance: 0,
      checkBoxFlag: false,
      mustCheckFlag: false,
      mustAmountFlag: false,
      showPassword: false,
      commitFlag: false,
      modalSize: 'md'
    };
  },
  // validations: {
  //   form: {
  //     payPassword: {
  //       required,
  //       pwdValid: rules.txnPwdValid,
  //     }
  //   },
  //   commitFlag: false
  // },
  // computed: {
  //   errorMsgs() {
  //     return {
  //       payPassword: {
  //         required: this.$t('v.common.txnPwd.required'),
  //         pwdValid: this.$t('v.common.txnPwd.format'),
  //       }
  //     }
  //   }
  // },
  watch: {
    show: function(val) {
      this.modalShow = val;
      if (val) {
        this.checkBoxFlag = false;
        this.getAssetsList();
      }
    },
    modalShow: function(val) {
      this.$emit('update:show', val);
      if (!val) {
        this.form.payPassword = '';
        this.$refs.observer.reset();
        //this.$v.form.$reset();
      }
    },
    'item.id': function(val) {
      /* if (val === 2) {
             this.title = item.displayName;
           } else if(val === 3) {
             this.title = item.displayName;
           }*/
      //to work with changes in someOtherProp
    },
    checkBoxFlag: function(val) {
      if (this.checkBoxFlag) {
        this.mustCheckFlag = false;
      }
    }
  },
  methods: {
    ...mapActions([actionTypes.GET_ASSETS_ACTION]),
    getAssetsList() {
      this.GET_ASSETS_ACTION().then(res => {
        let balance = res.data.assertList.filter(item => {
          return item.coinName === this.item.coinSymbol;
        })[0];
        this.userBalance = `${balance.available}  ${balance.coinName}`;
        this.availBalance = balance.available || 0;

        if (this.price > this.availBalance) {
          this.errorNotify(this.$t('v.trade.amount.insufficientBalance'));
          this.mustAmountFlag = true;
        }
      });
    },
    joinPartnerModalSubmitBtn() {
      //this.$v.form.$touch();

      // if (!this.checkBoxFlag || this.commitFlag || this.$v.form.$error) {
      //   this.mustCheckFlag = true;
      //   return;
      // }
      if (!this.checkBoxFlag || this.commitFlag) {
        this.mustCheckFlag = true;
        return;
      }

      if (this.price > this.availBalance) {
        this.errorNotify(this.$t('v.trade.amount.insufficientBalance'));
        return;
      }

      this.mustCheckFlag = false;
      this.commitFlag = true;

      let data = {
        coinId: 1004,
        configId: this.item.id,
        payPassword: this.form.payPassword,
        price: this.item.price,
        upgrade: this.item.isUpgrade
      };

      partnerApi
        .subscribePartner(data)
        .then(() => {
          if (data.configId > 1) {
            this.successNotify(this.$t('success.partnerInvite2'));
          } else {
            this.successNotify(this.$t('success.partnerInvite'));
          }
          this.commitFlag = false;
          this.checkBoxFlag = false;
          this.$emit('update:show', false);
          this.$emit('refreshAffAndParInfo');
          // this.$v.form.$reset();
        })
        .catch(() => {
          this.commitFlag = false;
        });
    }
  },
  mounted() {}
};
</script>

<style lang="stylus" scoped>
.join-partner-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.join-partner-title {
  font-weight: 600;
  margin-bottom: 20px;
  font-size: 20px;
}

.join-partner-desc {
  font-size: 14px;
  max-width: 80%;
}

.join-partner-table {
  background-color: #F5F5F8;
  padding: 15px 30px;
  min-width: 50%;
  justify-content: center;
}

.join-partner-label {
  font-size: 14px;
  float: right;
}

.join-partner-data {
  color: #1E49AC;
  font-weight: bold;
  font-size: 14px;
}

.partnerInvite-form {
  width: 50%;
}

.available-balance {
  font-size: 12px;
  font-weight: bold;
  color: #252834;
  margin-bottom: 10px;
}

@media screen and (min-width: 320px) {
  .join-partner-table {
    background-color: #F5F5F8;
    padding: 15px;
    min-width: 50%;
    justify-content: center;
  }

  .partnerInvite-form {
    min-width: 100%;
  }
}

@media screen and (min-width: 360px) {
  .partnerInvite-form {
    min-width: 80%;
  }
}

@media screen and (min-width: 408px) {
  .partnerInvite-form {
    min-width: 75%;
  }
}

@media screen and (min-width: 494px) {
  .partnerInvite-form {
    min-width: 70%;
  }
}

@media screen and (min-width: 768px) {
  .partnerInvite-form {
    min-width: 75%;
  }
}

@media screen and (max-width: 430px) {
  .join-partner-title {
    margin-bottom: 15px;
  }

  .join-partner-desc {
    min-width: 100%;
  }

  .join-partner-desc {
    font-size: 12px;
  }

  .join-partner-label {
    font-size: 12px;
    padding-right:10px;
  }

  .join-partner-data {
    font-size: 12px;
    word-break: keep-all;
  }
}

.errorMessageStyle {
  max-width: 320px;
}

.mustCheckErrorText {
  color: #DB2828;
  font-size: 12px;
}

.terms-and-condition-spacing {
  margin: 0px 0px 0px 8px;
}

.check-box-wrap {
  display: flex;
  flex-direction: row;
  font-size: 13px;
}

.must-check-error-text {
  color: #DB2828;
  font-size: 12px;
}

.v-input--selection-controls {
  margin-top: 0px;
}

.v-text-field::v-deep {
    .theme--light.v-messages {
      color: red;
    }
}
</style>
